import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import shipingService from "../services/shiping-service";
import cogoToast from "cogo-toast";
import Loader from "react-loader-spinner";
import { Modal } from "react-responsive-modal";
import { selectUsers } from "../state/reducers/userSlice";
import moment from "moment";
const AuditFacTab = () => {
  const { register, getValues, setValue, handleSubmit } = useForm({});
  const { user } = useSelector(selectUsers);
  const [finalControlData, setFinalControlData] = useState([]);
  const [finalHighDollar, setFinalHighDollar] = useState([]);
  const [totalFridgeData, setTotalFridgeData] = useState(0);
  const [auditCheckedAll, setAuditCheckedAll] = useState(true);
  const [auditFacility, setAuditFacility] = useState(0);
  const [loading, setLoading] = useState(false);
  const [defaultCheckedCount, setDefaultCheckedCount] = useState(0);
  const [totalCheckBoxesCount, setTotalCheckBoxesCount] = useState(0);
  const [currentBoxCount, setCurrentBoxCount] = useState(0);
  const [totalSprint, setTotalSprint] = useState(0);
  const [disableSave, setDisableSave] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [rxCodes, setRXCodes] = useState([]);
  const [rxCodeError, setRxCodeError] = useState('');

  const dateObj = new Date();
  let day = dateObj.getDay();
  let flag =
    !(day === 5 || day === 6) &&
    !(
      user?.userRole === "DEPARTMENT_ADMIN" &&
      user?.department === "FULFILLMENT"
    );
  const canSelectBatch =
    user?.userRole === "DEPARTMENT_ADMIN" &&
    (user?.department === "FULFILLMENT" || user?.department === "ORDER_ENTRY");
  const [sendFridgeFlag, setSendFridgeFlag] = useState(false);
  const [gridDataResponse, setGridDataResponse] = useState({});
  const [fridges, setFridges] = useState(0);
  function setGridData(gridResponse, fridgeFlag) {
    if (fridgeFlag) {
      setFinalControlData(
        gridResponse.list.filter((res) => res.group_name === "C")
      );
      setFinalHighDollar(
        gridResponse.list.filter((res) => res.group_name === "$$")
      );
      setTotalFridgeData(
        parseInt(gridResponse.list.filter((e) => e.is_fridge).length)
      );
      let defaultCheckCount = gridResponse.list.filter(
        (e) => e.is_checked
      ).length;
      setDefaultCheckedCount(defaultCheckCount);
      let totalCheckCount = gridResponse?.list.length;
      setTotalCheckBoxesCount(totalCheckCount);
      setAuditCheckedAll(defaultCheckCount === totalCheckCount ? false : true);
      setTotalSprint(gridResponse.scripts);
    } else {
      setFinalControlData(
        gridResponse.list.filter(
          (res) => res.group_name === "C" && !res.is_fridge
        )
      );
      setFinalHighDollar(
        gridResponse.list.filter(
          (res) => res.group_name === "$$" && !res.is_fridge
        )
      );
      setTotalFridgeData(0);
      let defaultCheckCount = gridResponse.list.filter(
        (e) => e.is_checked && !e.is_fridge
      ).length;
      setDefaultCheckedCount(defaultCheckCount);
      let totalCheckCount = gridResponse.list.filter(
        (e) => !e.is_fridge
      ).length;
      setTotalCheckBoxesCount(totalCheckCount);
      setAuditCheckedAll(defaultCheckCount === totalCheckCount ? false : true);
      setTotalSprint(gridResponse.scripts - gridResponse.fridges);
    }
  }
  const shpDropBox = async (e) => {
    if (e.key === "Enter") {
      let shpFacId = getValues("shpFacId");
      if (shpFacId) {
        let lastChar = shpFacId.toString().charAt(shpFacId.length - 1);
        shpFacId = isNaN(lastChar)
          ? shpFacId.toString().substring(0, shpFacId.length - 1)
          : shpFacId;

        shpFacId = shpFacId.substr(shpFacId.length - 4).trim();
        setAuditFacility(shpFacId);
        let dropRxForSearch = (getValues("dropRxCode") || "").replace(/[*_]/g, "");
        let rxNumForSearch = dropRxForSearch.length >= 11
          ? parseInt(dropRxForSearch.substring(0, 8))
          : dropRxForSearch ? parseInt(dropRxForSearch) : undefined;
        handleAuditSearch(shpFacId, rxNumForSearch || undefined);
        setDefaultCheckedCount(0);
        setGridDataResponse({});
        try {
          setLoading(true);
          let response = await shipingService.getShpDropList(shpFacId);
          let showFridges = false;
          if (response) {
            setGridDataResponse(response);
            let fridgeCount = parseInt(response.list.filter((e) => e.is_fridge).length);
            if (response?.box_num === 0) {
              showFridges = fridgeCount === 0 ? false : true;
            } else {
              showFridges = response.fridge_items
            }
            setSendFridgeFlag(showFridges)
            setFridges(fridgeCount);
          }
          if (response?.list.length > 0) {
            document.getElementById("dropRxCode").select();
          } else {
            setFinalControlData([]);
            setFinalHighDollar([]);
            setTotalFridgeData(0);
            setLoading(false);
            setAuditCheckedAll(false);
            setTotalSprint(response.scripts);
          }
          setDisableSave(response?.is_last_box);
          setCurrentBoxCount(parseInt(response?.box_num) + 1);
          document.getElementById("dropRxCode").select();
          setLoading(false);
        } catch (e) {
          setValue("shpFacId", "");
          setRXCode("");
          setIsDisabled(false);
          setDisableSave(false);
          setGridDataResponse({});
          setDname("");
          setFridges(0);
          setSendFridgeFlag(false);
          document.getElementById("shpFacId").focus();
          setTotalSprint(0);
          setFinalControlData([]);
          setFinalHighDollar([]);
          setTotalFridgeData(0);
          setAuditCheckedAll(true);
          setLoading(false);
          setCurrentBoxCount(1);
          const { hide } = cogoToast.error(
            "Error getting Audit Station Data. Please try after sometime.",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        }
      }
    }
  };
  async function checkDropFac(dropRxCodeValue) {
    setLoading(true);
    let dropRxCode = dropRxCodeValue;
    if (dropRxCode) {
      try {
        let seq = 0;
        let num = 0;
        dropRxCode = dropRxCode.replace(/[*_]/g, "");
        if (dropRxCode.length >= 11) {
          num = parseInt(dropRxCode.substring(0, 8));
          seq = parseInt(dropRxCode.substring(8, 11));
        } else if (dropRxCode.length <= 8) {
          num = parseInt(dropRxCode);
        }
        let facIdForSearch = (getValues("shpFacId") || "").toString();
        if (facIdForSearch) {
          let lc = facIdForSearch.charAt(facIdForSearch.length - 1);
          facIdForSearch = isNaN(lc) ? facIdForSearch.substring(0, facIdForSearch.length - 1) : facIdForSearch;
          facIdForSearch = facIdForSearch.substr(facIdForSearch.length - 4).trim();
        }
        handleAuditSearch(facIdForSearch || undefined, num || undefined);
        if (finalControlData.length > 0 || finalHighDollar.length > 0) {
          if (document.getElementById(num + "_" + seq) && document.getElementById(num + "_" + seq).checked !== true) {
            document.getElementById(num + "_" + seq).checked = true;

            if (defaultCheckedCount + 1 === totalCheckBoxesCount) {
              setAuditCheckedAll(false);
            }
            setDefaultCheckedCount(defaultCheckedCount + 1);
            let selectedDateData = JSON.parse(
              document.getElementById(num + "_" + seq).value
            );
            let params = {
              fac_id: auditFacility,
              rxf_num: selectedDateData?.rxf_num,
              seq_num: selectedDateData?.seq_num,
              pat_id: selectedDateData?.pat_id,
              drg_id: selectedDateData?.drg_id,
              is_checked: true,
            };
            await shipingService.submitAuditFac(params);
            document.getElementById("dropRxCode").select();
            document.getElementById("dropRxCode").value = "";
            setLoading(false);
          } else {
            setErrorDialogOpen(true);
          }
        }
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error Submitting details. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        document.getElementById("dropRxCode").select();
        document.getElementById("dropRxCode").value = "";
        setLoading(false);
      }
    }
    setLoading(false);
  }
  const saveAudit = async (data) => {
    if (auditFacility) {
      setLoading(true);
      let auditCheck = getValues("auditCheck");
      let defaultCheck = (day === 5 || day === 6) ? false : true;
      try {
        let lastChar = auditFacility.toString().charAt(auditFacility.length - 1);
        let params = {
          fac_id: isNaN(lastChar)
            ? auditFacility.toString().substring(0, auditFacility.length - 1)
            : auditFacility,
          is_last_box: auditCheck,
          fridge_items:
            gridDataResponse?.box_num === 0 &&
              parseInt(gridDataResponse.fridges) === 0
              ? defaultCheck
              : sendFridgeFlag,
        };
        let resp = await shipingService.saveAuditForm(params);
        if (resp) {
          const { hide } = cogoToast.success("Audit done successfully.", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
          setCurrentBoxCount(0);
          setTotalSprint(0);
          setFinalControlData([]);
          setFinalHighDollar([]);
          setTotalFridgeData(0);
          setAuditCheckedAll(true);
          setGridDataResponse({});
          setFridges(0);
          setSendFridgeFlag(false);
          setValue("shpFacId", "");
          setDname("");
          setRXCode("");
          setIsDisabled(false);
        } else {
          setCurrentBoxCount(0);
          setTotalSprint(0);
          setFinalControlData([]);
          setFinalHighDollar([]);
          setTotalFridgeData(0);
          setAuditCheckedAll(true);
          setValue("shpFacId", "");
          setRXCode("");
          setIsDisabled(false);
          setDname("");
          const { hide } = cogoToast.error(
            "Error submitting Audit details. Please contact administartor.",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        }
      } catch (e) {
        setCurrentBoxCount(0);
        setTotalSprint(0);
        setFinalControlData([]);
        setFinalHighDollar([]);
        setTotalFridgeData(0);
        setAuditCheckedAll(true);
        setGridDataResponse({});
        setRXCode("");
        setIsDisabled(false);
        setFridges(0);
        setSendFridgeFlag(false);
        setValue("shpFacId", "");
        setDname("");
        const { hide } = cogoToast.error(
          "Error submitting Audit details. Please contact administartor.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
      setLoading(false);
    }
  };
  useEffect(() => {
    if (gridDataResponse?.list?.length > 0) {
      setGridData(gridDataResponse, sendFridgeFlag);
    }
  }, [sendFridgeFlag, gridDataResponse])

  const clearAllData = () => {
    setValue("shpFacId", "");
    setValue("dropRxCode", "");
    setRXCode("");
    setIsDisabled(false);
    setDname("");
    setFinalControlData([]);
    setFinalHighDollar([]);
    setTotalFridgeData(0);
    setAuditCheckedAll(true);
    setAuditFacility(0);
    setLoading(false);
    setDefaultCheckedCount(0);
    setTotalCheckBoxesCount(0);
    setCurrentBoxCount(0);
    setTotalSprint(0);
    setDisableSave(false);
    setSendFridgeFlag(false);
    setGridDataResponse({});
    setFridges(0);
    setAuditSearchData([]);
    setSelectedRows(new Set());
  }
  const [dname, setDname] = useState("");
  const [rxCode, setRXCode] = useState("");

  // Audit search state
  const [auditSearchData, setAuditSearchData] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState(new Set());

  function getCheckboxState(row) {
    if (row.batch_id > 0 && row.scan_user > 0) {
      return { checked: true, disabled: false };
    }
    if (row.batch_id > 0) {
      return { checked: true, disabled: true };
    }
    return { checked: false, disabled: false };
  }

  const handleCheckboxChange = async (row) => {
    if (!(row.rxf_number > 0)) {
      const { hide } = cogoToast.error(
        "Cannot select — RX Number is not valid.",
        { hideAfter: 5, onClick: () => { hide(); } }
      );
      return;
    }
    if (!(row.id > 0)) {
      const { hide } = cogoToast.error(
        "No batch record found.",
        { hideAfter: 5, onClick: () => { hide(); } }
      );
      return;
    }
    const rowId = row.id;
    const newSetBatch = !selectedRows.has(rowId);
    setSelectedRows((prev) => {
      const next = new Set(prev);
      if (newSetBatch) {
        next.add(rowId);
      } else {
        next.delete(rowId);
      }
      return next;
    });
    try {
      const result = await shipingService.setBatch(rowId, newSetBatch);
      let toastMessage;
      if (result === true) {
        toastMessage = "Batch set successfully";
      } else if (result === false) {
        toastMessage = "Batch unset successfully";
      } else {
        toastMessage = String(result);
      }
      const { hide } = cogoToast.success(
        toastMessage,
        { hideAfter: 5, onClick: () => { hide(); } }
      );
    } catch (e) {
      setSelectedRows((prev) => {
        const next = new Set(prev);
        if (newSetBatch) {
          next.delete(rowId);
        } else {
          next.add(rowId);
        }
        return next;
      });
      const { hide } = cogoToast.error(
        e.msg || `Failed to ${newSetBatch ? "set" : "unset"} batch for Facility ID: ${row.fac_id}, RX Number: ${row.rxf_number}. Please try again.`,
        { hideAfter: 15, onClick: () => { hide(); } }
      );
    }
  };

  const handleAuditSearch = async (facId, rxNum) => {
    if (!facId && !rxNum) return;

    const params = {};
    if (facId) params.fac_id = Number(facId);
    if (rxNum) params.rxf_number = Number(rxNum);

    try {
      setSearchLoading(true);
      const response = await shipingService.getAuditSearch(params);
      const data = Array.isArray(response) ? response : [];
      setAuditSearchData(data);
      const initialSelected = new Set(
        data.filter((row) => row.batch_id > 0).map((row) => row.id)
      );
      setSelectedRows(initialSelected);
      if (data.length === 0) {
        const { hide } = cogoToast.error("No records found.", {
          hideAfter: 10,
          onClick: () => { hide(); },
        });
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error retrieving audit records. Please try again.",
        { hideAfter: 15, onClick: () => { hide(); } }
      );
    } finally {
      setSearchLoading(false);
    }
  };

  const getScanDetails = async (e, rxCode) => {
    if (e.key === "Enter") {
      setRXCode(rxCode);
      setIsDisabled(true);
      setLoading(true);
      if (rxCode) {
        try {
          let resp = await shipingService.getFacDetails(rxCode);
          let fxd_delivry = resp.fdx_delivery ? resp.fdx_delivery : "";
          let fxd_remarks = resp.remarks ? resp.remarks : "";
          let fac_workflow = resp.fac_workflow ? resp.fac_workflow : "";
          //window.open('clinicalsolutions:'+resp.fac_dname+'|'+resp.fdx_code+'|'+resp.fdx_service+'|'+resp.fdx_delivery+'|'+'','_self');
          let facArr = [
            "CAFC-E",
            "CAFC-INF",
            "CAFC-W",
            "CCDF",
            "LPCC",
            "RDCC-EW",
            "RRCC",
            "SCAZ",
            "WCCC",
            "WHGA",
          ];
          const dateObj = new Date();
          let day = dateObj.getDay();
          let code = resp.fdx_code;
          if (
            resp.fdx_service.toString().startsWith("F") &&
            day === 5 &&
            facArr.find((element) =>
              resp.fdx_code.toString().startsWith(element)
            )
          ) {
            code = code + "P";
          }

          window.open(
            "clinicalsolutions:" +
            resp.fac_dname +
            "|" +
            code +
            "|" +
            resp.fdx_service +
            "|" +
            fxd_delivry +
            "|" +
            fxd_remarks +
            "|" +
            fac_workflow +
            "",
            "_self"
          );
          setValue("shpFacId", resp?.fac_id || "");
          setDname(resp?.fac_dname)
          shpDropBox(e);
          document.getElementById("dropRxCode").select();
        } catch (e) {
          setRXCode("");
          setIsDisabled(false);
          const errorMessage = e.msg && e.msg.includes("Not from the same facility.")
            ? "Error: Facility Mismatch for RX's scanned"
            : "Error retrieving details. Please contact administrator.";
          const { hide } = cogoToast.error(
            errorMessage,
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        }
      } else {
        const { hide } = cogoToast.error("Please enter RX Code.", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
      setLoading(false);
    }
  };
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const onErrorCloseModal = () => {
    setErrorDialogOpen(false);
    setValue("dropRxCode", "");
  };

  const handleRXCodeKeyDown = (e) => {
    if (e.key === 'Enter' && rxCode.trim() !== '') {
      e.preventDefault();
      const trimmedCode = rxCode.trim();

      // Check if the code already exists in rxCodes
      if (rxCodes.includes(trimmedCode)) {
        // Optionally show a message to the user that the code was already scanned
        const { hide } = cogoToast.warn("This RX code has already been scanned.", {
          hideAfter: 3,
          onClick: () => hide(),
        });
        setRXCode('');
        return;
      }

      const newRXCodes = [...rxCodes, trimmedCode];
      setRXCodes(newRXCodes);
      setRXCode('');

      if (newRXCodes.length === 3) {
        const formattedRX = newRXCodes.slice(0, 3).join('-');
        const mockEvent = {
          key: 'Enter',
          target: { value: formattedRX }
        };
        getScanDetails(mockEvent, formattedRX);
        setRXCodes([]);
      }
    }
  };

  const handleRXChange = (e) => {
    const value = e.target.value;
    setRXCode(value);

    // Add validation
    if (value.length > 0 && value.length < 7) {
      setRxCodeError('Invalid length of RX number');
    } else {
      setRxCodeError('');
    }
  };

  // Add this function to handle removing a code
  const removeRXCode = (indexToRemove) => {
    setRXCodes(rxCodes.filter((_, index) => index !== indexToRemove));
  };

  const handleScanClick = () => {
    if (rxCodes.length > 0) {
      const formattedRX = rxCodes.join('-');
      const mockEvent = {
        key: 'Enter',
        target: { value: formattedRX }
      };
      getScanDetails(mockEvent, formattedRX);
      setRXCodes([]);
    }
  };

  return (
    <div className="">
      <div
        className={`inline-block customtop z-50 absolute ${loading ? "show" : "hidden"
          }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000}
        />
      </div>
      <Modal open={errorDialogOpen} onClose={onErrorCloseModal} center>
        <div className="pt-10 px-8 pb-4 ">
          <h3
            className="text-lg leading-6 font-medium text-gray-900 text-center"
            id="modal-headline"
          >
            The rx number is not found or has already been scanned.Please press OK to enter the rx number again.
          </h3>
          <div className="flex justify-center">
            <button
              onClick={(e) => {
                if (!(e.clientX === 0 && e.clientY === 0)) {
                  setErrorDialogOpen(false);
                  setValue("dropRxCode", "");
                }

              }}
              type="button"
              className="mr-4 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-controls mb-3 mt-4 focus:outline-none"
            >
              Ok
            </button>

          </div>
          {/*
           */}
        </div>
      </Modal>
      <div className="px-4">
        <div className="inline-block w-1/3 ">
          <span className="inline-block mr-4">
            Total Scripts Count : <b>{auditSearchData.length}</b>
          </span>
        </div>
        <div className="inline-block w-1/3 relative">
          <div className="flex flex-row gap-4 w-full">
            <input
              type="text"
              name="rxCode"
              value={rxCode}
              id="rxCode"
              autoFocus={true}
              placeholder={`Scan ${3 - rxCodes.length} RX number(s)`}
              disabled={isDisabled}
              onChange={handleRXChange}
              onKeyDown={handleRXCodeKeyDown}
              className={`border focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-full ${rxCodeError ? 'border-red-500' : ''
                }`}
            />
            <button
              onClick={handleScanClick}
              disabled={rxCodes.length === 0}
              className={`text-white bg-header_bg rounded w-3/4 h-9`}
            >
              Less than 3 Scripts
            </button>
          </div>
          <div className="flex flex-wrap gap-2 mt-2">
            {rxCodeError && (
              <span className="text-hlred text-xs mt-1">{rxCodeError}</span>
            )}
            {rxCodes.map((code, index) => (
              <div key={index} className="bg-blue-100 text-blue-800 rounded-full px-3 py-1 text-sm flex items-center">
                {code}
                <button
                  type="button"
                  onClick={() => removeRXCode(index)}
                  className="ml-2 text-blue-500 hover:text-blue-700"
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>
        <div className="float-right mt-2">
          {/* <span>
            Box Count : <b>{currentBoxCount}</b>
          </span> */}
          <button
            onClick={() => clearAllData()}
            className={`text-white bg-header_bg rounded px-3 ml-4`}
          >
            Clear All
          </button>
        </div>
        <form>
          <ul className="mt-4">
            {fridges > 0 ? (
              <>
                <li
                  className={`inline-block text-xs leading-10 w-full mt-4 mb-4 bg-sendLastBox text-center`}
                >
                  <span className="ml-1 mt-4 inline-block text-2xl font-bold ">
                    Are you sending fridge items today ?
                  </span>
                  <input
                    type="checkbox"
                    name="sendFridgeItems"
                    id="sendFridgeItems"
                    disabled={flag}
                    checked={sendFridgeFlag}
                    ref={register({
                      required: false,
                    })}
                    value={sendFridgeFlag}
                    onChange={async (event) => {
                      setSendFridgeFlag(!sendFridgeFlag);
                    }}
                    className={`focus:outline-none focus:none ml-4 w-6 h-6 align-middle`}
                  />
                </li>
              </>
            ) : (
              ""
            )}
            <li
              className={`inline-block text-xs leading-6 text-menu_txt w-full mb-3`}
            >
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Facility
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <div>
                <input
                  type="text"
                  name="shpFacId"
                  id="shpFacId"
                  placeholder="Enter Facility ID"
                  ref={register({
                    required: "You must enter Facility ID",
                  })}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") shpDropBox(e);
                  }}
                  className={`border focus:outline-none h-11 rounded-md pl-2 font-normal ${dname ? "w-1/2" : "w-full"
                    }  text-fogotpwsd_login text-sm mr-4`}
                />
                {dname && (
                  <input
                    type="text"
                    name="facDname"
                    value={dname}
                    id="facDname"
                    disabled={true}
                    className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-1/3 text-fogotpwsd_login text-sm`}
                  />
                )}
              </div>
            </li>
            <li
              className={`inline-block text-xs leading-6 text-menu_txt w-full mb-3`}
            >
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                RX Code
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <input
                type="text"
                name="dropRxCode"
                id="dropRxCode"
                placeholder="Enter rxCode"
                onKeyDown={(e) => {
                  if (e.key === "Enter") checkDropFac(e.target.value);
                }}
                ref={register({
                  required: false,
                })}
                className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
            </li>
          </ul>
        </form>
      </div>
      <div className="px-4">
        <form onSubmit={handleSubmit(saveAudit)}>
          {false && totalFridgeData ? (
            <>
              <div className={`box1 w-full m-auto mb-4`}>
                <h1 className="text-center py-2 text-2xl font-bold bg-fridgeCount">
                  Fridge Scripts Count - {totalFridgeData}
                </h1>
              </div>
            </>
          ) : (
            ""
          )}
          {false && finalControlData.length > 0 ? (
            <>
              <div className={`box1 border w-full m-auto mb-4 rounded-md`}>
                <h1 className="bg-controls text-base font-bold text-center py-2  rounded-t-md ">
                  Controls - {finalControlData?.length}
                </h1>
                <div className="p-2 text-xs gridList overflow-x-auto">
                  <table className="min-w-full leading-normal ka-table">
                    <thead className="ka-thead">
                      <tr className="ka-thead-row">
                        <th className="ka-thead-cell">RX</th>
                        <th className="ka-thead-cell">Patient Name</th>
                        <th className="ka-thead-cell">Drug</th>
                        <th className="ka-thead-cell">Quantity</th>
                        <th className="ka-thead-cell">Facility ID</th>
                        <th className="ka-thead-cell">Drug Name</th>
                        <th className="ka-thead-cell">Type</th>
                        <th className="ka-thead-cell">Status</th>
                      </tr>
                    </thead>
                    <tbody className="ka-tbody">
                      {finalControlData
                        ? finalControlData.map((controlData, index) => {
                          return (
                            <tr key={index + controlData?.rxf_num} className="ka-row ">
                              <td className="ka-cell">
                                <p className="text-gray-900 whitespace-no-wrap">
                                  {controlData.rxf_num}
                                  {user?.userRole === "DEPARTMENT_ADMIN" &&
                                    user?.department === "FULFILLMENT" ? (
                                    <a
                                      className="bg-gray-200 hover:bg-gray-400 block whitespace-no-wrap cursor-pointer text-hlred font-bold	"
                                      onClick={() => {
                                        let seqNo = "";
                                        let rxNo = "";
                                        if (controlData.seq_num > 0) {
                                          rxNo = (
                                            "00000000" + controlData.rxf_num
                                          ).slice(-8);
                                          seqNo = (
                                            "000" + controlData.seq_num
                                          ).slice(-3);
                                        } else {
                                          rxNo = (
                                            "00000000" + controlData.rxf_num
                                          ).slice(-8);
                                        }
                                        setValue("dropRxCode", rxNo + seqNo);
                                        document
                                          .getElementById("dropRxCode")
                                          .focus();
                                      }}
                                    >
                                      Copy
                                    </a>
                                  ) : (
                                    ""
                                  )}
                                </p>
                              </td>
                              <td className="ka-cell">
                                <div className="flex">
                                  <div className="ml-3">
                                    <p className="text-gray-900 whitespace-no-wrap">
                                      {controlData.pat_name}
                                    </p>
                                  </div>
                                </div>
                              </td>
                              <td className="ka-cell">
                                <p className="text-gray-900 whitespace-no-wrap">
                                  {controlData.drg_name +
                                    "-" +
                                    controlData.drg_dose +
                                    "-" +
                                    controlData.strength}
                                </p>
                              </td>
                              <td className="ka-cell">
                                <p className="text-gray-900 whitespace-no-wrap text-center">
                                  {controlData.quantity}
                                </p>
                              </td>
                              <td className="ka-cell">
                                <p className="text-gray-900 whitespace-no-wrap">{controlData.fac_id}</p>
                              </td>
                              <td className="ka-cell">
                                <p className="text-gray-900 whitespace-no-wrap">{controlData.drg_name}</p>
                              </td>
                              <td className="ka-cell">
                                <p className="text-gray-900 whitespace-no-wrap  text-center">
                                  {controlData?.is_control === true
                                    ? "C"
                                    : ""}
                                  {controlData?.is_dollar === true
                                    ? "$$"
                                    : ""}
                                  {controlData?.is_fridge === true ? "F" : ""}
                                </p>
                              </td>
                              <td className="ka-cell">
                                <span className="relative inline-block px-3 py-1 font-semibold text-green-900 leading-tight">
                                  <span
                                    aria-hidden
                                    className="absolute inset-0 bg-green-200 opacity-50 rounded-full"
                                  ></span>
                                  <span className="relative">
                                    <>
                                      {controlData?.is_checked ? (
                                        <input
                                          type="checkbox"
                                          id={`${controlData.rxf_num +
                                            "_" +
                                            controlData.seq_num
                                            }`}
                                          value={`${JSON.stringify(
                                            controlData
                                          )}`}
                                          checked={true}
                                          disabled={true}
                                        />
                                      ) : (
                                        <input
                                          type="checkbox"
                                          id={`${controlData.rxf_num +
                                            "_" +
                                            controlData.seq_num
                                            }`}
                                          value={`${JSON.stringify(
                                            controlData
                                          )}`}
                                          disabled={true}
                                        />
                                      )}
                                    </>
                                  </span>
                                </span>
                              </td>
                            </tr>
                          );
                        })
                        : null}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          {false && finalHighDollar.length > 0 ? (
            <>
              <div className={`box1 border w-full m-auto mb-4 rounded-md`}>
                <h1 className="bg-yellow text-base font-bold text-center py-2 bg-bodybgrnd rounded-t-md">
                  $$ - {finalHighDollar?.length}
                </h1>
                <div className="p-2 text-xs gridList overflow-x-auto">
                  <table className="table-auto w-full text-left ka-table">
                    <thead className="ka-thead">
                      <tr className="ka-thead-row">
                        <th className="ka-thead-cell">RX</th>
                        <th className="ka-thead-cell">Patient Name</th>
                        <th className="ka-thead-cell">Drug</th>
                        <th className="ka-thead-cell">Quantity</th>
                        <th className="ka-thead-cell">Facility ID</th>
                        <th className="ka-thead-cell">Drug Name</th>
                        <th className="ka-thead-cell">Type</th>
                        <th className="ka-thead-cell">Status</th>
                      </tr>
                    </thead>
                    <tbody className="ka-body">
                      {finalHighDollar
                        ? finalHighDollar.map((highDollar, index) => {
                          return (
                            <tr key={index + highDollar?.rxf_num} className="ka-row">
                              <td className="ka-cell">
                                <p className="text-gray-900 whitespace-no-wrap">
                                  {highDollar.rxf_num}
                                  {user?.userRole === "DEPARTMENT_ADMIN" &&
                                    user?.department === "FULFILLMENT" ? (
                                    <a
                                      className="bg-gray-200 hover:bg-gray-400 block whitespace-no-wrap cursor-pointer text-hlred font-bold"
                                      onClick={() => {
                                        let rxNo = "";
                                        let seqNo = "";
                                        if (highDollar.seq_num > 0) {
                                          rxNo = (
                                            "00000000" + highDollar.rxf_num
                                          ).slice(-8);
                                          seqNo = (
                                            "000" + highDollar.seq_num
                                          ).slice(-3);
                                        } else {
                                          rxNo = (
                                            "00000000" + highDollar.rxf_num
                                          ).slice(-8);
                                        }
                                        setValue("dropRxCode", rxNo + seqNo);
                                        document
                                          .getElementById("dropRxCode")
                                          .focus();
                                      }}
                                    >
                                      Copy
                                    </a>
                                  ) : (
                                    ""
                                  )}
                                </p>
                              </td>
                              <td className="ka-cell">
                                <div className="flex">
                                  <div className="ml-3">
                                    <p className="text-gray-900 whitespace-no-wrap">
                                      {highDollar.pat_name}
                                    </p>
                                  </div>
                                </div>
                              </td>
                              <td className="ka-cell">
                                <p className="text-gray-900 whitespace-no-wrap">
                                  {highDollar.drg_name +
                                    "-" +
                                    highDollar.drg_dose +
                                    "-" +
                                    highDollar.strength}
                                </p>
                              </td>
                              <td className="ka-cell">
                                <p className="text-gray-900 whitespace-no-wrap  text-center">
                                  {highDollar.quantity}
                                </p>
                              </td>
                              <td className="ka-cell">
                                <p className="text-gray-900 whitespace-no-wrap">{highDollar.fac_id}</p>
                              </td>
                              <td className="ka-cell">
                                <p className="text-gray-900 whitespace-no-wrap">{highDollar.drg_name}</p>
                              </td>
                              <td className="ka-cell">
                                <p className="text-gray-900 whitespace-no-wrap  text-center">
                                  {highDollar?.is_dollar === true ? "$$" : ""}
                                  {highDollar?.is_fridge === true ? "F" : ""}
                                </p>
                              </td>
                              <td className="ka-cell">
                                <span className="relative inline-block px-3 py-1 font-semibold text-green-900 leading-tight">
                                  <span
                                    aria-hidden
                                    className="absolute inset-0 bg-green-200 opacity-50 rounded-full"
                                  ></span>
                                  <span className="relative">
                                    <>
                                      {highDollar?.is_checked ? (
                                        <input
                                          type="checkbox"
                                          id={`${highDollar.rxf_num +
                                            "_" +
                                            highDollar.seq_num
                                            }`}
                                          value={`${JSON.stringify(
                                            highDollar
                                          )}`}
                                          checked={true}
                                          disabled={true}
                                        />
                                      ) : (
                                        <input
                                          type="checkbox"
                                          id={`${highDollar.rxf_num +
                                            "_" +
                                            highDollar.seq_num
                                            }`}
                                          value={`${JSON.stringify(
                                            highDollar
                                          )}`}
                                          disabled={true}
                                        />
                                      )}
                                    </>
                                  </span>
                                </span>
                              </td>
                            </tr>
                          );
                        })
                        : null}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          {auditSearchData.length > 0 && (
            <div className="border w-full m-auto mb-4 rounded-md pt-2">
              <div className="p-2 text-xs gridList overflow-x-auto">
                <table className="min-w-full leading-normal ka-table">
                  <thead className="ka-thead">
                    <tr className="ka-thead-row">
                      {canSelectBatch && <th className="ka-thead-cell text-center">Select</th>}
                      <th className="ka-thead-cell text-center">RX Number</th>
                      <th className="ka-thead-cell text-center">Facility ID</th>
                      <th className="ka-thead-cell text-center">Drug Name</th>
                      <th className="ka-thead-cell text-center">RFID</th>
                      <th className="ka-thead-cell text-center">Fridge</th>
                      <th className="ka-thead-cell text-center">Control</th>
                      <th className="ka-thead-cell text-center">Dollar</th>
                      <th className="ka-thead-cell text-center">Batch ID</th>
                    </tr>
                  </thead>
                  <tbody className="ka-tbody">
                    {auditSearchData.map((row) => {
                      const { checked, disabled } = getCheckboxState(row);
                      const isChecked = disabled ? checked : selectedRows.has(row.id);
                      return (
                        <tr key={row.id} className="ka-row">
                          {canSelectBatch && (
                            <td className="ka-cell text-center">
                              <input
                                type="checkbox"
                                checked={isChecked}
                                disabled={disabled}
                                onChange={() => !disabled && handleCheckboxChange(row)}
                                className="w-4 h-4 align-middle"
                              />
                            </td>
                          )}
                          <td className="ka-cell text-center">
                            <p className="text-gray-900 whitespace-no-wrap">{row.rxf_number}</p>
                          </td>
                          <td className="ka-cell text-center">
                            <p className="text-gray-900 whitespace-no-wrap">{row.fac_id}</p>
                          </td>
                          <td className="ka-cell text-center">
                            <p className="text-gray-900 whitespace-no-wrap">{row.drg_name}</p>
                          </td>
                          <td className="ka-cell text-center">
                            <p className="text-gray-900 whitespace-no-wrap">{row.rfid}</p>
                          </td>
                          <td className="ka-cell text-center">
                            <p className="text-gray-900 whitespace-no-wrap">{row.is_fridge ? "F" : ""}</p>
                          </td>
                          <td className="ka-cell text-center">
                            <p className="text-gray-900 whitespace-no-wrap">{row.is_control ? "C" : ""}</p>
                          </td>
                          <td className="ka-cell text-center">
                            <p className="text-gray-900 whitespace-no-wrap">{row.is_dollar ? "$$" : ""}</p>
                          </td>
                          <td className="ka-cell text-center">
                            <p className="text-gray-900 whitespace-no-wrap">{row.batch_id}</p>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {/* <div>
            <span className="inline-block w-1/2 mt-4">
              <div
                className={`float-right text-2xl bg-red-400 px-4 py-4 rounded-lg font-bold ${auditCheckedAll ? "" : "bg-lastBox"
                  }`}
              >
                <label>Last Box</label>
                <input
                  type="checkbox"
                  className="pt-10 ml-4 w-10 h-10 align-middle"
                  name="auditCheck"
                  id="auditCheckAll"
                  disabled={auditCheckedAll}
                  ref={register({
                    required: false,
                  })}
                />
              </div>
            </span>
            <span>
              <button
                type="submit"
                disabled={disableSave}
                className={`text-white rounded font-bold text-2xl h-12 w-1/4 bg-secondary bg-login_btn mt-4 focus:outline-none float-right mr-4  ${disableSave ? "cursor-not-allowed" : ""
                  }`}
                aria-label="Save"
              >
                SAVE
              </button>
            </span>
          </div> */}
        </form>
      </div>

    </div>
  );
};
export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(AuditFacTab)
);